import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Discover from "@/pages/Discover";
import { Login, Signup } from "@/pages/Auth";
import ClipperDashboard from "@/pages/ClipperDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import LeaderboardPage from "@/pages/LeaderboardPage";

function Protected({ children, admin }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--muted)" }}>Loading…</div>;
  if (!user) return <Navigate to={admin ? "/admin/login" : "/login"} state={{ from: loc }} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Discover />} />
            <Route path="/campaign/:slug" element={<Discover />} />
            <Route path="/leaderboard" element={<LeaderboardPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/admin/login" element={<Login admin />} />
            <Route path="/dashboard" element={<Protected><ClipperDashboard /></Protected>} />
            <Route path="/admin" element={<Protected admin><AdminDashboard /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
